import React, { useState } from "react";

const granularityOptions = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
  { value: "custom", label: "Custom Range" },
];

const DateSelector = ({ value, granularity, onChange }) => {
  const [localGranularity, setLocalGranularity] = useState(granularity || "day");
  const [localValue, setLocalValue] = useState(value || new Date().toISOString().slice(0, 10));
  const [customRange, setCustomRange] = useState({ from: "", to: "" });

  const handleGranularityChange = (e) => {
    const newGranularity = e.target.value;
    setLocalGranularity(newGranularity);
    if (newGranularity !== "custom") {
      setLocalValue(new Date().toISOString().slice(0, 10));
      onChange && onChange(new Date().toISOString().slice(0, 10), newGranularity);
    } else {
      setCustomRange({ from: "", to: "" });
      onChange && onChange({ from: "", to: "" }, newGranularity);
    }
  };

  const handleDateChange = (e) => {
    setLocalValue(e.target.value);
    onChange && onChange(e.target.value, localGranularity);
  };

  const handleCustomRangeChange = (e) => {
    const { name, value } = e.target;
    const updatedRange = { ...customRange, [name]: value };
    setCustomRange(updatedRange);
    if (updatedRange.from && updatedRange.to) {
      onChange && onChange(updatedRange, "custom");
    }
  };

  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      <select
        className="form-select w-auto"
        value={localGranularity}
        onChange={handleGranularityChange}
      >
        {granularityOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {localGranularity === "day" && (
        <input
          type="date"
          className="form-control w-auto"
          value={localValue}
          onChange={handleDateChange}
        />
      )}
      {localGranularity === "week" && (
        <input
          type="week"
          className="form-control w-auto"
          value={localValue}
          onChange={handleDateChange}
        />
      )}
      {localGranularity === "month" && (
        <input
          type="month"
          className="form-control w-auto"
          value={localValue}
          onChange={handleDateChange}
        />
      )}
      {localGranularity === "year" && (
        <select
          className="form-select w-auto"
          value={localValue.slice(0, 4)}
          onChange={(e) => {
            const year = e.target.value;
            setLocalValue(year + "-01-01");
            onChange && onChange(year + "-01-01", "year");
          }}
        >
          {Array.from({ length: new Date().getFullYear() + 10 - 2024 }, (_, i) => 2024 + i).map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      )}
      {localGranularity === "custom" && (
        <>
          <input
            type="date"
            name="from"
            className="form-control w-auto"
            value={customRange.from}
            onChange={handleCustomRangeChange}
            placeholder="From"
          />
          <span>to</span>
          <input
            type="date"
            name="to"
            className="form-control w-auto"
            value={customRange.to}
            onChange={handleCustomRangeChange}
            placeholder="To"
          />
        </>
      )}
    </div>
  );
};

export default DateSelector; 